/*! jquery.cookie v1.4.1 | MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});

if($('.slider-1').length > 0){
  $('.slider-1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.home-slider-nav',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  });
}

if($('.home-slider-nav').length > 0){
  $('.home-slider-nav').slick({
    slidesToShow:3,
    slidesToScroll: 1,
    asNavFor: '.slider-1',
    dots: true,
    centerMode: true,
    arrows: false,
    focusOnSelect: true
  });
}

if($('.feature_col_s1').length > 0){
  $('.feature_col_s1').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1
  });
}


// $(window).on('resize orientationChange', function(event) {
//   $('.feature_col_s1').slick('reinit'); 
  
// });
$("input.form-field-number ").change(function(){
//     alert(this.value);
  if(this.value <=0){
  this.value = 1;
  }
});

$('.site-header-actions .login_action a').click(function(e){
 $("form").attr('autocomplete', 'off');
  e.preventDefault();
  $("html").addClass("login_popped_Up");
  $.magnificPopup.open({
    items: {
      src: '#signin_popup',
      type: 'inline'
//       callbacks: {
//         beforeOpen: function () {
//           if ($(window).width() < 700) {
//             this.st.focus = false;
//           } else {
//             this.st.focus = '#name';
//           }
//         }
//       }
    }
  });
  $.magnificPopup.instance.close = function () {
    if ($("html").hasClass("login_popped_Up")) {
      $("html").removeClass("login_popped_Up");
    }
    $('form').find("input[type=text], input[type=password]").val("");
     $.magnificPopup.proto.close.call(this);
};
});


if(localStorage["prodHandle"]){  
  var template = jQuery('#compare-produc-template');    
  var prodHandleLSload = JSON.parse(localStorage["prodHandle"]); 
  var prodHandleLSload1 = JSON.parse(localStorage["prodHandle"]); 
  if($('.jscompare_checkbox input:checkbox').length > 0){
    $('.jscompare_checkbox input:checkbox').each(function () {
      $(this).prop("checked", ($.inArray($(this).attr('data-handle'), prodHandleLSload) != -1));
    });
  }  
    
  if($('#compare-products').length > 0){
    var moveAlong = function() {
      var lengthTodo = prodHandleLSload1.length;
      if(lengthTodo){
        var params = {
          type: 'GET',
          url: '/products/'+prodHandleLSload1[0]+'.js',
          dataType: 'json',
          cache: false,
          success: function(product) { 
            template.tmpl(product).appendTo($('#compare-products')); 
            $("span.price-"+product.variants[0].id).html(formatMoney(product.price, Shopify.money_format ));
//             $("span.regular_prc sup").append('</br><span class="msrp">MSRP</span>');
            if(product.available){
					// console.log(product);
                  }else{
                    $("a.comparePrd_addtocart[data-varid='"+product.variants[0].id+"']").text("Sold Out");
					// $("a.comparePrd_addtocart[data-varid='"+product.variants[0].id+"']").attr("disabled","disabled");
                    }
                  if(cust == 1){
                  $("a.comparePrd_addtocart").show();
                  }
            prodHandleLSload1.shift();
            moveAlong();
          },
          error: function() {
            prodHandleLSload1.shift();
            moveAlong();
          }
        };
        $.ajax(params);
      } else {
        console.log("DONE");
        // remove product from compare
        if($('.comparePrd_remove').length > 0){
          $('.comparePrd_remove a').click(function(){
            var data_handle = $(this).attr('data-handle');
            prodHandleLSload = jQuery.grep(prodHandleLSload, function(value) {
              return value != data_handle;
            });
            localStorage["prodHandle"] = JSON.stringify(prodHandleLSload);
            $(this).parents('li.product.product-item').fadeOut().remove();
            
            if(prodHandleLSload.length > 0){
              $('.site-header-compare--count').attr('data-header-compare-count',prodHandleLSload.length).addClass('visible');
              jQuery('.no_compare_prd').hide();
              jQuery('.cd-products-comparison-table').show();
            }
            else{
//               window.location.href = '/';
              $('.site-header-compare--count').removeClass('visible');
              jQuery('.no_compare_prd').show();
              jQuery('.cd-products-comparison-table').hide();
            }
            
            if(prodHandleLSload.length > 3){
            	jQuery('.cd-table-navigation').show()
            }
            else{
              jQuery('.cd-table-navigation').hide();
            }
            
          });
        } 
             var desc_text="";
       jQuery('#compare-products li').each(function(){
          if(jQuery(this).find('.comparePrd_desc').length > 0){
            	desc_text =$(this).find('.comparePrd_desc').text();
                desc_text = desc_text.replace(/(?:\r\n|\r|\n)/g, '');  
                var three_type_des=desc_text.split(/<\/?(?:div|p|br)[^>]*>\s*/im);

            
            	var str =$(this).find('.comparePrd_desc').text();
                var start1=''
                var start2=''
                var compare_d = [];
				var final_desc="";
                for (var i = 0; i < str.length; i++) {
                if(str.substring(i, i-5)=="</h3>")
                {
                start1=i;
//                 console.log("start1 "+start1);
                }
                if(str.substring(i, i-4)=="<h3>")
                {
                if(i-4!=0)
                {
                start2=i;
//                 console.log("start2 "+start2);
                }
                if(start1!='' && start2!='')
                {
//                 console.log(str.substring(start1, start2-4));
                compare_d.push(str.substring(start1, start2-4));// console.log(str.substring(start1, start2)=="</h3>");
	    	            }
    	            }
                }
				final_desc = str.substring(start1,str.length);
         		compare_d.push(final_desc);
//             compare_d.push(final_desc_2);
             console.log(compare_d); 
            
            for(var j=0;j<three_type_des.length;j++){
          
//               console.log(three_type_des);
              
                $(this).find('.comparePrd_desc').html(compare_d[0]);
                $(this).find('.comparePrd_desc').show();
		
  
                $(this).find('.comparePrd_dim').html(compare_d[1]);
                $(this).find('.comparePrd_dim').show();
          
        
                $(this).find('.comparePrd_ship').html(compare_d[2]);
                $(this).find('.comparePrd_ship').show();
          
		}
            
         
  
            
            
//             console.log($(this).find('.comparePrd_desc').html());
//             var myContent = $(this).find('.comparePrd_desc').text().replace(/(<([^>]+)>)/ig,"");
//             var shortText = jQuery.trim(myContent).substring(0, 320).split(" ").slice(0, -1).join(" ") + "";
//             $(this).find('.comparePrd_desc').html(shortText);
//             $(this).find('.comparePrd_desc').show();
          }
        });
        
        if(jQuery('#compare-products li.product.product-item').length > 3){
        	jQuery('.cd-table-navigation').show();
        }
        else{
        	jQuery('.cd-table-navigation').hide();
        }
        
        if ($(".spr-badge").length > 0) {
			$.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
		}
        
        
        jQuery('#compare-products li .comparePrd_addtocart').click(function(e){
          e.preventDefault();
          var variant_id = jQuery(this).attr('data-varid');
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              "quantity": 1,
              "id": variant_id},
            dataType: 'json',
            success: function() { 
              window.location.href = '/cart'; 
            }
          });
        });        
      }    
    }
    
    moveAlong();
  }

}else{
	var prodHandleLSload = [];
} 

// console.log(prodHandleLSload);
if(prodHandleLSload.length > 0){
	$('.site-header-compare--count').attr('data-header-compare-count',prodHandleLSload.length).addClass('visible');
}
else{
  if(jQuery('#compare-products').length > 0){
//   	window.location.href = '/'; 
    jQuery('.no_compare_prd').show();
    jQuery('.cd-products-comparison-table').hide();
  }
  else{
  	jQuery('.no_compare_prd').hide();
    jQuery('.cd-products-comparison-table').show();
  }
}


// complare product - local storage code
$('body').on('click','.jscompare_checkbox input',function(){  
  if($(this).is(':checked')){
    var searchIDs = $('.jscompare_checkbox input:checked').map(function(){
      return $(this).attr('data-handle');
    });

    var prodHandle = searchIDs.get();
    var temp = $.merge( prodHandleLSload, prodHandle );
    var prodHandleLSfinal = $.unique(temp.sort());  

    localStorage["prodHandle"] = JSON.stringify(prodHandleLSfinal);

    var prodHandleLS = JSON.parse(localStorage["prodHandle"]);  
//     console.log(prodHandleLS);  
	
    if(prodHandleLS.length > 0){
      if(prodHandleLS.length > 5){
            var notSelected = $(this).attr('data-handle');
    		console.log(notSelected);
        	if(localStorage["prodHandle"]){
                prodHandleLSload = jQuery.grep(prodHandleLSload, function(value) {
                  return value != notSelected;
                });
                localStorage["prodHandle"] = JSON.stringify(prodHandleLSload);
                if(prodHandleLSload.length > 0){
                  $('.site-header-compare--count').attr('data-header-compare-count',prodHandleLSload.length).addClass('visible');
                }
                else{
                  $('.site-header-compare--count').removeClass('visible');
                }
              }
      		return false;
      }else{
      $('.site-header-compare--count').attr('data-header-compare-count',prodHandleLS.length).addClass('visible');
      }
    }
    
  }
  
  else{
    var notSelected = $(this).attr('data-handle');
//     console.log(notSelected); 

    if(localStorage["prodHandle"]){

      prodHandleLSload = jQuery.grep(prodHandleLSload, function(value) {
        return value != notSelected;
      });

//       console.log(prodHandleLSload);  
      localStorage["prodHandle"] = JSON.stringify(prodHandleLSload);
      if(prodHandleLSload.length > 0){
        $('.site-header-compare--count').attr('data-header-compare-count',prodHandleLSload.length).addClass('visible');
      }
      else{
      	$('.site-header-compare--count').removeClass('visible');
      }
    }
    else{
      console.log('1236'); 
      console.log(localStorage["prodHandle"]); 
    }
  }
  
});
$(document).ready(function(){
  if(localStorage["prodHandle"]){
var prodHandleLS = JSON.parse(localStorage["prodHandle"]);  
  if(prodHandleLS.length >= 5){
      if($('.jscompare_checkbox input').is(':checked')){
         
      }else{
       $('.jscompare_checkbox input').attr("disabled","disabled");
      }
 	}
  }
});

function openTab(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


$('#careers a').each(function(){
  $(this).magnificPopup({
    type:'inline',
    midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  });
});

$('.get_profit').magnificPopup({
  type:'inline',
  midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});

$(".order_histry .on_off_img img").on({
  	mouseenter: function () {
      	var imgSrcOn = $(this).attr('src').replace('off','on');
      	$(this).attr('src',imgSrcOn)        
    },
    mouseleave: function () {
      	var imgSrcOff = $(this).attr('src').replace('on','off');
      	$(this).attr('src',imgSrcOff);        
    }
});


/* Compare Product script */

//alert($("#compare-products li").length); 
var next_click_counter = 0;
var prev_click_counter = 0;

$('.cd-table-navigation li a.prev').click(function () {
  $('.cd-table-navigation li a.next').removeClass('inactive');
  if(prev_click_counter>0) {
    prev_click_counter -= 1;
    next_click_counter -= 1;
  }
  if(prev_click_counter>=1) {
  }else{
    $('.cd-table-navigation li a.prev').addClass('inactive');    
  }
  $('.cd-table-navigation li a.next').show();
  var leftPos = $('.cd-products-wrapper').scrollLeft();

  $(".cd-products-wrapper").animate({
    scrollLeft: leftPos - 310
  }, 100);
  return false;
});

$('.cd-table-navigation li a.next').click(function () {
  $('.cd-table-navigation li a.prev').removeClass('inactive');
  
  var total_compare = $('ul#compare-products li.product-item').length;
  var max_click_allowed = total_compare % 3;
  next_click_counter += 1;
  prev_click_counter += 1;
  
  
  if(max_click_allowed == 0){
  	max_click_allowed = 3;
  }
  else{
  	max_click_allowed = max_click_allowed;
  }
  
  if(next_click_counter > 3 && total_compare > 6){
    next_click_counter = 1;

    if(next_click_counter<=max_click_allowed){
    }else{
      $('.cd-table-navigation li a.next').addClass('inactive');      
    }
  }
  else{
    if(next_click_counter<max_click_allowed){

    }else{   
      if(total_compare > 6){
        if(prev_click_counter > 3){
          $('.cd-table-navigation li a.next').addClass('inactive'); 
        }        
      }else{
      	$('.cd-table-navigation li a.next').addClass('inactive'); 
      }
    }
  }
    
  var leftPos = $('.cd-products-wrapper').scrollLeft();
//   $(".cd-products-wrapper").animate({
//     scrollLeft: leftPos + 310
//   }, 800);
    $(".cd-products-wrapper").animate({
    scrollLeft: leftPos + 310
  }, 100);
  return false;
});


// jQuery( "#slider_range" ).flatslider({
//   min: 10000, max: 500000,
//   step: 1000,
//   values: [45000, 130000],
//   range: true,
//   einheit: '&euro;'
// });

if($( "#slider-range" ).length > 0){
  $( "#slider-range" ).slider({
    range: true,
    min: 0,
    max: 500,
    values: [ 75, 300 ],
    slide: function( event, ui ) {
      $( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
    }
  });
  $( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
                     " - $" + $( "#slider-range" ).slider( "values", 1 ) );

}
function masking(input,textbox,e) {
 
// adds hyphen after 3 and then after 6 characters
if (input.length == 2) {
if(e.keyCode != 8){
input = input + '-';
}
textbox.value = input;
}
}
$(document).ready(function() {


                                               
  $(".product--price .price--main .money").before('<span class="your_price">Your Price:</span>');
  $('.logout_link').on('click', function(e) {
    e.preventDefault();
    window.location.href = "/account/logout";
 
//     $.ajax({
//       type: "POST",
//       url: '/cart/clear.js',
//       success: function(){
//         window.location.href = "/account/logout";
//       },
//       dataType: 'json'
//     });
    
});
  
//     $('.site-header-search-form').on('keyup keypress', function(e) {
//   var keyCode = e.keyCode || e.which;
//   if (keyCode === 13) { 
//     e.preventDefault();
//     return false;
//   }
// });
        var remember = $.cookie('remember');
        if (remember == 'true') 
        {
            var email = $.cookie('email');
            var password = $.cookie('password');
            // autofill the fields
            $('#customer_email').val(email);
            $('#customer_password').val(password);
        }


    $("#customer_login").submit(function() {
        if ($('#Save_ID').is(':checked')) {
            var email = $('#customer_email').val();
            var password = $('#customer_password').val();

            // set cookies to expire in 14 days
            $.cookie('email', email, { expires: 14 });
            $.cookie('password', password, { expires: 14 });
            $.cookie('remember', true, { expires: 14 });                
        }
        else
        {
            // reset cookies
            $.cookie('email', null);
            $.cookie('password', null);
            $.cookie('remember', null);
        }
  });
  
  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 200);
  }

  ALAcheck();

  function customALA() {
    if(jQuery('.dd_step_1').length > 0) {
      clearInterval(isALARendered);    
      $('.dd_step_1').parent().wrapAll('<div class="div_for_step1 customr-field-step"></div>');
      $('.dd_step_2').parent().wrapAll('<div class="div_for_step2 customr-field-step" style="display: none;"></div>');
      $('.dd_step_3').parent().wrapAll('<div class="div_for_step3 customr-field-step" style="display: none;"></div>');
      $('.dd_step_4').parent().wrapAll('<div class="div_for_step4 customr-field-step" style="display: none;"></div>');
      
      $('.dealer_app').append('<p class="step-des step-des1"><strong>M&M Merchandisers is a wholesale only distributor. To become a dealer, you will need to be prepared to show proof of your valid business, including: EIN, Sales Tax certificate, Assumed Name certificate or other form of resale business.</strong></p>');
      $('.dealer_app').append('<p class="step-des step-des4" style="display: none;"><strong>Please review the <a href="/pages/terms-conditions">Terms & Conditions</a> for partnering with M&M Merchandisers and working with M&M Merchandiser’s Dealers Solution.</strong><a href="/" class="pdf_dwnld">Cick here to download terms & conditions as a PDF document</a></p>');
      
      // clone country - state
      var $options = $(".billing_country select > option").clone();
      $('.shipping_country select, .country_op select').html($options);
      
//       $.ajax({
//         url: "https://cdn-customr.heliumdev.com/assets/services/countries.json",
//         cache: false,
//         success: function(html){
//           console.log(html);
//         }
//       });
      
      $('.dd_stepttl').click(function(e){
      	var data_ddtab = $(this).attr('data-ddtab');
        
        //validation 
        if(!$(this).parent('li').hasClass('black_all') && !$(this).parent('li').hasClass('active')){
          var reqfld_count = 0;
          $('.customr-field-step:visible .customer-required input[type="text"]').each(function(){
            if($(this).val() == ''){
              $(this).addClass('error_class');   
              reqfld_count = reqfld_count + 1;
              $('.reqError').show();
            }
            else{
              if($(this).parents('.customer-required').hasClass('date_validation')){
                var date_val = $(this).val();
                var filter = new RegExp("(0[123456789]|10|11|12)([-])([1-2][0-9][0-9][0-9])");
                if(filter.test(date_val)){
                  $(this).removeClass('error_class');
                }
                else{
                  reqfld_count = reqfld_count + 1;
                  $(this).addClass('error_class'); 
                  $('.reqError').show();
                }
              }
              else if ($(this).parents('.customer-required').hasClass('federal_taxid_validation')){
                var federal_taxid_val = $(this).val();
                var filter1 = /^\d{2}\-?\d{7}$/;
                if(filter1.test(federal_taxid_val)){
                  $(this).removeClass('error_class');
                }
                else{
                  reqfld_count = reqfld_count + 1;
                  $(this).addClass('error_class'); 
                  $('.reqError').show();
                }              
              }else if ($(this).parents('.customer-required').hasClass('confirm_pass_val')){
                var pass = $("div.password input[type='password']").val();
                var confirm_pass = $(this).val();

                if(pass == confirm_pass){
                  $(this).removeClass('error_class');
                }
                else{
                  reqfld_count = reqfld_count + 1;
                  $(this).addClass('error_class'); 
                  $('.reqError').show();
                }   
              }
              else{
                $(this).removeClass('error_class');              
              }
            }
          });
          
          $('.customr-field-step:visible .customer-required input[type="email"]').each(function(){
            if($(this).val() == ''){
              $(this).addClass('error_class');   
              reqfld_count = reqfld_count + 1;
              $('.reqError').show();
            }
            else{
              var emailadd_val = $(this).val();
              var filter2 = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
              if(filter2.test(emailadd_val)){
                $(this).removeClass('error_class');
              }
              else{
                reqfld_count = reqfld_count + 1;
                $(this).addClass('error_class'); 
                $('.reqError').show();
              }  
            }
          });
          
          $('.customr-field-step:visible .customer-required input[type="password"]').each(function(){
            if($(this).val() == ''){
              $(this).addClass('error_class');   
              reqfld_count = reqfld_count + 1;
              $('.reqError').show();
            }
            else{
              if ($(this).parents('.customer-required').hasClass('confirm_pass_val')){
                var pass = $("div.password input[type='password']").val();
                var confirm_pass = $(this).val();

                if(pass == confirm_pass){
                  $(this).removeClass('error_class');
                }
                else{
                  reqfld_count = reqfld_count + 1;
                  $(this).addClass('error_class'); 
                  $('.reqError').show();
                }   
              }
              else{
                $(this).removeClass('error_class');              
              }
            }
          });
          
          $('.customr-field-step:visible .customer-required select').each(function(){
            if($(this).val() == ''){
              $(this).addClass('error_class');   
              reqfld_count = reqfld_count + 1;
              $('.reqError').show();
            }
            else{
              $(this).removeClass('error_class');              
            }
          });
        }
        
                
        if(reqfld_count == 0 || $(this).parent('li').hasClass('black_all')){
          $('.reqError').hide();
          
          $('.dealer_app li').removeClass('active');
          $('.customr-field-step').hide();
          $(this).parents('li').addClass('active');
          $('.'+data_ddtab+'.customr-field-step').show();
        
          if(data_ddtab == 'div_for_step4'){$('#customer-fields .form-footer').show();}
          else{$('#customer-fields .form-footer').hide();}    

          $('.dealer_app li.active').prevAll('li').addClass('black_all');
          $('.dealer_app li.active').nextAll('li').removeClass('black_all'); 

          if(data_ddtab == 'div_for_step1'){$('.dealer_app p.step-des1').show();}
          else{$('.dealer_app p.step-des1').hide();}

          if(data_ddtab == 'div_for_step4'){$('.dealer_app p.step-des4').show();}
          else{$('.dealer_app p.step-des4').hide();}
          
           var i = 1;
          $("li.active").nextAll().each(function(){
            // alert("grey"+i);
            $('.dealer_app li').removeClass("grey"+i);
            $(this).removeClass();
            $(this).addClass("grey"+i);
//             console.log(i);
            i=i+1;
          });
          
        }
        
      });
      
      $('.have_website').click(function(){
        if($(this).find('input').is(':checked')){
          $('.web_address').removeClass('customer-required');
          $('.web_address input').removeClass('error_class');
        }
        else{
          $('.web_address').addClass('customer-required');
          $('.web_address input').addClass('error_class');
        }
      });
      
      
      $('.div_for_step1').append('<div class="div_back_next"><a href="javascript:void(0);" class="step_next" data-navi="div_for_step2">Next</a><div>');
      $('.div_for_step2').append('<div class="div_back_next"><a href="javascript:void(0);" class="step_back" data-navi="div_for_step1">Back</a><a href="javascript:void(0);" class="step_next" data-navi="div_for_step3">Next</a><div>');
      $('.div_for_step3').append('<div class="div_back_next"><a href="javascript:void(0);" class="step_back" data-navi="div_for_step2">Back</a><a href="javascript:void(0);" class="step_next" data-navi="div_for_step4">Next</a><div>');
      $('#customer-fields .form-footer').prepend('<a href="javascript:void(0);" class="step_back" data-navi="div_for_step3">Back</a>');
      
      $('.step_next, .step_back').click(function(){
        var data_navi = $(this).attr('data-navi');        
        $('.dealer_app [data-ddtab="'+data_navi+'"]').trigger('click');
      });
      
      $('#create_customer input:checkbox').each(function(e){
      	$(this).attr('id','dd_checkbox'+e);
        $(this).closest('label').attr('for','dd_checkbox'+e);
        
        var this_inp = $(this);
        $(this_inp).insertBefore($(this).parent('label'));
      });
      $('#create_customer input:radio').each(function(e){
        $(this).attr('id','dd_radio'+e);
        $(this).closest('label').attr('for','dd_radio'+e);
        
        var this_inp = $(this);
        $(this_inp).insertBefore($(this).parent('label'));
      });
      
      
      $('[class*="from_"]').each(function(){ 
        $(this).find('input').blur(function() {
          var class_names = $(this).parents('.customr-field').attr('class').split(' ');
          for (var i = 0; i < class_names.length; i++) {
            var c_name = class_names[i];
            if(c_name.indexOf('from_') > -1){
              var split_nm = class_names[i].split('from_');
              var final_nm = split_nm[1];
              if($(this).val() != ''){
              	$('.to_'+final_nm).find('input[type="text"]').val($(this).val());
              }
            }
          }
        });
      });
      
      $('.step2_same_add').click(function(){
		if($(this).find('input').is(':checked')){
          $('.div_for_step2 [class*="billing_"]').each(function(){          
            var class_names = $(this).attr('class').split(' ');
            for (var i = 0; i < class_names.length; i++) {
              var c_name = class_names[i];
              if(c_name.indexOf('billing_') > -1){
                var split_nm = class_names[i].split('billing_');
                var final_nm = split_nm[1];
                if($(this).find('input[type="text"]').val() != '' && $(this).find('input[type="text"]').val() != undefined){
                  $('.div_for_step2 .shipping_'+final_nm).find('input[type="text"]').val($(this).find('input[type="text"]').val());
                }
                if($(this).find('input[type="radio"]').val() != '' && $(this).find('input[type="radio"]').val() != undefined){                
                  $('.div_for_step2 .shipping_'+final_nm).find('input[type="radio"][value="'+$(this).find('input[type="radio"]:checked').val()+'"]').prop('checked', true).trigger('click');
                }
                if($(this).find('select').val() != '' && $(this).find('select').val() != '-1'){
                  $('.div_for_step2 .shipping_'+final_nm).find('select').val($(this).find('select').val()).trigger('change');
                }
              }
            }
          });
          
           if($('.shipping_country select').val() != '' && $('.shipping_country select').val() != '-1'){
                    console.log($('.billing_country select').val() +"-"+ $('.billing_state select').val());
                    setTimeout(function(){
                      $('.div_for_step2 .shipping_state').find('select').val($('.billing_state select').val()).trigger('change');
                      $('.div_for_step2 .shipping_state select option').show();
                    }, 300);
                }
          
          
        }
        else{
          $('.div_for_step2 [class*="shipping_"]').each(function(){
			$(this).find('input[type="text"]').val('');
            $(this).find('select').val('').trigger('change');
          });
          
          setTimeout(function(){ 
            $('.div_for_step2 .shipping_state select').val('').trigger('change');
            $('.div_for_step2 .shipping_state select option').hide();
            $(".div_for_step2 .shipping_state select").append('<option value="" selected="selected">State</option>');
            $('.div_for_step2 .shipping_state select').removeClass("dd-selected");
          }, 300);
          
        }
      }); 
      
      
      $('.step3_same_primary').click(function(){
        if($(this).find('input').is(':checked')){
          $('.div_for_step3 [class*="primary_"]').each(function(){   
            var class_names = $(this).attr('class').split(' ');
            for (var i = 0; i < class_names.length; i++) {
              var c_name = class_names[i];
              if(c_name.indexOf('primary_') > -1){
                var split_nm = class_names[i].split('primary_');
                var final_nm = split_nm[1];
                if($(this).find('input').val() != '' || $(this).find('input').val() != 'undefined'){
                  $('.div_for_step3 .order_'+final_nm).find('input').val($(this).find('input').val());
                }
              }
            }
          });
        }
        else{
          $('.div_for_step3 [class*="order_"]').each(function(){
			$(this).find('input').val('');
          });
        }
      });
      
      $('.step3_same_pri_ord').click(function(){
        if($(this).find('input').is(':checked')){
          $('.step3_same_order').find('input').prop("checked",false);
          $('.div_for_step3 [class*="primary_"]').each(function(){   
            var class_names = $(this).attr('class').split(' ');
            for (var i = 0; i < class_names.length; i++) {
              var c_name = class_names[i];
              if(c_name.indexOf('primary_') > -1){
                var split_nm = class_names[i].split('primary_');
                var final_nm = split_nm[1];
                if($(this).find('input').val() != '' || $(this).find('input').val() != 'undefined'){
                  $('.div_for_step3 .billing_'+final_nm).find('input').val($(this).find('input').val());
                }
              }
            }
          });
        }
        else{
          $('.div_for_step3 [class*="billing_"]').each(function(){
			$(this).find('input').val('');
          });
        }
      });
      
      $('.step3_same_order').click(function(){
        if($(this).find('input').is(':checked')){
          $('.step3_same_pri_ord').find('input').prop("checked",false);
          $('.div_for_step3 [class*="order_"]').each(function(){   
            var class_names = $(this).attr('class').split(' ');
            for (var i = 0; i < class_names.length; i++) {
              var c_name = class_names[i];
              if(c_name.indexOf('order_') > -1){
                var split_nm = class_names[i].split('order_');
                var final_nm = split_nm[1];
                if($(this).find('input').val() != '' || $(this).find('input').val() != 'undefined'){
                  $('.div_for_step3 .billing_'+final_nm).find('input').val($(this).find('input').val());
                }
              }
            }
          });
        }
        else{
          $('.div_for_step3 [class*="billing_"]').each(function(){
			$(this).find('input').val('');
          });
        }
      });
      
      
      $('.shipping_country select').change(function(){
        var conValue = $(this).val();
        var staSelect = $('.shipping_state select');

        $.getJSON("https://cdn.shopify.com/s/files/1/2593/9010/files/countries.json?16078262088559664963", function(result){
          var found_names = $.grep(result, function(v) {
            return v.name === conValue;
          });

          console.log(found_names);
          
//           if(found_names.hasOwnProperty('provinces')){
            var province = found_names[0]['provinces'];
            staSelect.empty();
            if(province.length > 0){
              for (var i = 0; i < province.length; i++) {
                staSelect.append('<option>'+ province[i].name +'</option>');
              }
            }
            else{
              staSelect.attr('disabled','disabled');
            }
//           }
        });
      });
      
      
      $('.account-page select').change(function(){
        if($(this).find(':selected').val() != ''){$(this).find(':selected').parent().addClass('dd-selected');}
        else{$(this).find(':selected').parent().removeClass('dd-selected');}
      });
      
//       $('input[type="submit"]').attr('disabled','disabled');
            
      var htmltext="<div class='alert' style='display:none;'>you must agree to the terms and conditions before submitting application</div>";
	  $("#customer-fields .div_for_step4 textarea").before(htmltext);
      
      $('input[type="submit"]').click(function(e){
        
		if(!$('.i_certify').find('input').is(':checked')){
          e.preventDefault();
          $(".alert").show();
          $('body').removeClass('regi_loader');
        }
        else{
          /*
          @Author: Luis C. from Yokel 
          @Brief: Add tracking code for when become dealer form gets submitted
          @Date: July 25 2019 
          */
          	console.log("form has been submitted"); 
            dataLayer.push({
              event: 'formBecomeDealerFilled'
            });
          
          /*
          @Author: Luis C. from Yokel 
          @Brief: Remove loader and use default form loader, reason being that when password is too short and there is an error, the loader will not dissapear 
          @Date: September 04 2019 
          */
//         	$('body').addClass('regi_loader');
        }
       

		});

      $('.i_certify').click(function(){
        if($(this).find('input').is(':checked')){
        	$('input[type="submit"]').removeAttr('disabled');
          $(".alert").hide();
        }
        else{
        	$('input[type="submit"]').attr('disabled','disabled');
			$(".alert").show();
          
        }
      });
      
      //custom css
      $('.float_right').parent().css('float','right');
      $('.field_onethrd1').parent().css('width','21%');
      $('.field_onethrd2').parent().css('width','29%');
      
      if($(window).width() < 551){
        $('.float_right').parent().css('float','left');
        $('.field_onethrd1').parent().css('width','50%');
        $('.field_onethrd2').parent().css('width','50%');
      }
      
      $('.date_validation input').attr('readonly','readonly');
      $('.state_resaleid_validation input').attr('maxlength', '12');
      $('.federal_taxid_validation input').attr('maxlength', '10');
	 $('.federal_taxid_validation input').attr('onblur', 'return masking(this.value,this,event);');
     $('.federal_taxid_validation input').attr('onKeyPress', 'return masking(this.value,this,event);');

      
      $('.state_resaleid_validation input').on('keydown keyup', function(e) {
//         if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57 ) && (e.which < 96 || e.which > 105)) {
//           return false;
//         }
              var yourInput = $(this).val();
              re = /[A-Za-z`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi;
              var isSplChar = re.test(yourInput);
              if(isSplChar)
              {
                  var no_spl_char = yourInput.replace(/[A-Za-z`-~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                  $(this).val(no_spl_char);
              }
      });
      
      $('.federal_taxid_validation input').on('keydown keyup', function(e) {
//         if (e.which != 8 && e.which != 0 && e.which != 189 && (e.which < 48 || e.which > 57 ) && (e.which < 96 || e.which > 105)) {
//           return false;
//         }
         if (e.which == 189 || e.which == 109){
          return false;
         }else{
          var yourInput = $(this).val();
          re = /[A-Za-z`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi;
          var isSplChar = re.test(yourInput);
          if(isSplChar)
          {
              var no_spl_char = yourInput.replace(/[A-Za-z`-~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/gi, '');
              $(this).val(no_spl_char);
          }
         }
      });
      
      
      $(function() {
        $('.date_validation input').datepicker({
          dateFormat: "mm-yy",
          changeMonth: true,
          changeYear: true,
          showButtonPanel: true,
          onClose: function(dateText, inst) {
            function isDonePressed(){
              return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
            }
            if (isDonePressed()){
              var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
              var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
              $(this).datepicker('setDate', new Date(year, month, 1)).trigger('change');
              $('.date-picker').focusout();
            }
          },
          beforeShow : function(input, inst) {
            inst.dpDiv.addClass('month_year_datepicker')
            if ((datestr = $(this).val()).length > 0) {
              year = datestr.substring(datestr.length-4, datestr.length);
              month = datestr.substring(0, 2);
              $(this).datepicker('option', 'defaultDate', new Date(year, month-1, 1));
              $(this).datepicker('setDate', new Date(year, month-1, 1));
              $(".ui-datepicker-calendar").hide();
            }
          }
        })
      });
      
    }   
  }     
  
});
$(document).ready(function() {
$(".category li" ).each(function( index ) {
   if($(this).hasClass('filter-item--active'))
   {
     $('#category .filterclear').css('display','inline-block');
   }
});
$(".Color li" ).each(function( index ) {
   if($(this).hasClass('filter-item--active'))
   {
     $('#Color .filterclear').css('display','inline-block');
   }
});
$(".brand li" ).each(function( index ) {
   if($(this).hasClass('filter-item--active'))
   {
     $('#brand .filterclear').css('display','inline-block');
   }
});
$(".price li" ).each(function( index ) {
   if($(this).hasClass('filter-item--active'))
   {
      $('#price .filterclear').css('display','inline-block');
   }
});
  $("#category .filterclear").click(function(){
    $('.filter-group--grid .category .filter-icon--remove').trigger('click');
  });
   $("#Color .filterclear").click(function(){
    $('.filter-group--grid .Color .filter-icon--remove').trigger('click');
  });
   $("#brand .filterclear").click(function(){
    $('.filter-group--grid .brand .filter-icon--remove').trigger('click');
  });
   $("#price .filterclear").click(function(){
    $('.filter-group--grid .price .filter-icon--remove').trigger('click');
  });
});



/*
@author: Luis C. 
@brief: Remove the "information secure" pop up on the become a dealer form 
@date: 7/26/2019


$(function () {
  setTimeout(function(){   $("a.popup-modal").trigger("click"); }, 3000);
  
  $(document).on('click', 'a.popup-modal', function (e) {
  $("html").addClass("info-secure");
  });
  
	$('.popup-modal').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: '#username',
		modal: true
	});
	$(document).on('click', '.popup-modal-dismiss', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
      $("html").removeClass("info-secure"); 
	});
  
});

*/



function readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    $('#complogo')
                        .attr('src', e.target.result);
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

function readImgURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    $('#edit_complogo')
                        .attr('src', e.target.result);
                };

                reader.readAsDataURL(input.files[0]);
            }
        }
$(document).ready(function() {
  $('button#submit-new').click(function(e) {
    // Initializing Variables With Form Element Values
    var firstname = $('#customer_addr_new_firstname').val();
    var lastname = $('#customer_addr_new_lastname').val();
    var company = $('#customer_addr_new_company').val();  
    var addr1 = $('#customer_addr_new_address1').val();
    var addr2 = $('#customer_addr_new_address2').val();
    var zip = $('#customer_addr_new_zip').val();
    var city = $('#customer_addr_new_city').val();
    var phone = $('#customer_addr_new_phone').val();

    // To Check Empty Form Fields.
    var error_count = 0;
    $('#address_form_new input[type="text"]').each(function(){
       if($(this).val() == ''){
              $(this).addClass('error_class');   
              error_count = error_count + 1;
            }
            else{
              if($(this).hasClass('firstname') || $(this).hasClass('lastname')|| $(this).hasClass('company')){
                var values = $(this).val();
                var filter = /^[a-zA-Z\s&/.(),'-]+$/;
                if(filter.test(values)){
                  $(this).removeClass('error_class');
                }
                else{
                  error_count = error_count + 1;
                  $(this).addClass('error_class'); 
                }
              }
               else if ($(this).hasClass('address1') || $(this).hasClass('address2')){
                var add_data = $(this).val();
                var filter1 =  /^[0-9a-zA-Z\s#.,;:'°]+$/ ;
                if(filter1.test(add_data)){
                  $(this).removeClass('error_class');
                }
                else{
                  error_count = error_count + 1;
                  $(this).addClass('error_class'); 
                }
               }
              else if ($(this).hasClass('city')){
                var city = $(this).val();
                var filter_city=  /^[0-9a-zA-Z\s-,.;'&/.()]+$/ ;
                if(filter_city.test(city)){
                  $(this).removeClass('error_class');
                }
                else{
                  error_count = error_count + 1;
                  $(this).addClass('error_class'); 
                }              
              } else if ($(this).hasClass('phone')){
                var phone = $(this).val();
                var filter2 =  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9\s]*$/ ;
                if(filter2.test(phone)){
                  $(this).removeClass('error_class');
                }
                else{
                  error_count = error_count + 1;
                  $(this).addClass('error_class'); 
                }              
              }else if ($(this).hasClass('zip')){
                var zip = $(this).val();
                var filter3 = /^[A-Za-z0-9\s]*$/;
                if(filter3.test(zip)){
                  $(this).removeClass('error_class');
                }
                else{
                  error_count = error_count + 1;
                  $(this).addClass('error_class'); 
                }              
              }
              else{
                $(this).removeClass('error_class');              
              }
            }
          });
    
    if(error_count != 0){
    return false;
    }else{
    return true;
    }
  });

  
});


$(document).ready(function(e){
  if(cust == 1){
    $.ajax({
      type: 'POST',
      url: 'https://mmwholesale.info/mmw/comp_info/get_comp_info.php',
      data: {"customer_id":cust_id},
      beforeSend: function(){
        $('.submit_button').attr("disabled","disabled");
        $('#comp_info_reg').css("opacity",".5");
      },
      success: function(response){
        if(response!="Failed"){
          var response2json = JSON.parse(response);	
          var cmp_logo = "https://mmwholesale.info/mmw/comp_info/uploads/"+response2json.comp_logo;
          console.log(response2json);

          $("img#company_logo").attr("src",cmp_logo);
          $(".user_info h3#company_name").html(response2json.comp_name);
          $(".user_info p#company_web").text(response2json.comp_webaddress);
          $("form#comp_info_reg").hide();
          $("div.user-filled-detail").show(); 
        }else{
          $('#comp_info_reg').css("opacity","");
          $(".submit_button").removeAttr("disabled");
          $("form#comp_info_reg").show();
          $("div.user-filled-detail").hide();

        }
      }
    });
  }


  $("#edit_info_link").on('click',function(e){

    e.preventDefault();
    if(cust == 1){
      $.ajax({
        type: 'POST',
        url: 'https://mmwholesale.info/mmw/comp_info/get_comp_info.php',
        data: {"customer_id":cust_id},
        beforeSend: function(){
          $('.submit_button').attr("disabled","disabled");
          $('#edit_comp_info').css("opacity",".5");
        },
        success: function(response){
          if(response!="Failed"){
            var response2json = JSON.parse(response);	
            var cmp_logo = "https://mmwholesale.info/mmw/comp_info/uploads/"+response2json.comp_logo;
            // 			 console.log(response2json);

            $("img#edit_complogo").attr("src",cmp_logo);
            //               $("#edit_upload_btn").val(response2json.comp_logo);

            $("#edit_compname").val(response2json.comp_name);
            $("#edit_compwebaddress").val(response2json.comp_webaddress);

            $('#edit_comp_info').css("opacity","");
            $(".submit_button").removeAttr("disabled");
            $("form#edit_comp_info").show();
            $("div.user-filled-detail").hide();
            $("form#comp_info_reg").hide(); 
          }else{
            $("form#edit_comp_info").hide();
            $("form#comp_info_reg").hide();
            $("div.user-filled-detail").show(); 
          }
        }
      });
    }
  });


  $("form#comp_info_reg").on('submit', function(e){
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: 'https://mmwholesale.info/mmw/comp_info/comp_info.php',
      data: new FormData(this),
      contentType: false,
      cache: false,
      processData:false,
      beforeSend: function(){
        $('.submit_button').attr("disabled","disabled");
        $('#comp_info_reg').css("opacity",".5");
      },
      success: function(msg){
        $('.statusMsg').html('');
        if(msg == 'ok'){
          $('#comp_info_reg')[0].reset();
          $('.statusMsg').html('<span style="font-size:18px;color:#34A853">Form data submitted successfully.</span>');
        }else{
          $('.statusMsg').html('<span style="font-size:18px;color:#EA4335">Some problem occurred, please try again.</span>');
        }
        $('#comp_info_reg').css("opacity","");
        $(".submit_button").removeAttr("disabled");
        location.reload();
      }
    });
  });

  $("form#edit_comp_info").on('submit', function(e){
    e.preventDefault();
    $.ajax({
      type: 'POST',
      url: 'https://mmwholesale.info/mmw/comp_info/edit_comp_info.php',
      data: new FormData(this),
      contentType: false,
      cache: false,
      processData:false,
      beforeSend: function(){
        $('.submit_button').attr("disabled","disabled");
        $('#comp_info_reg').css("opacity",".5");
      },
      success: function(msg){
        $('.statusMsg').html('');
        if(msg == 'ok'){
          $('#comp_info_reg')[0].reset();
          $('.statusMsg').html('<span style="font-size:18px;color:#34A853">Form data submitted successfully.</span>');
        }else{
          $('.statusMsg').html('<span style="font-size:18px;color:#EA4335">Some problem occurred, please try again.</span>');
        }
        $('#comp_info_reg').css("opacity","");
        $(".submit_button").removeAttr("disabled");
        location.reload();
      }
    });
  });
  //file type validation
  $("#upload_btn,#edit_upload_btn").change(function() {
    var file = this.files[0];
    var imagefile = file.type;
    var match= ["image/jpeg","image/png","image/jpg"];

    var FileSize = file.size / 1024 / 1024; // in MB


    if(!((imagefile==match[0]) || (imagefile==match[1]) || (imagefile==match[2]))){
      alert('Please select a valid image file (JPEG/JPG/PNG).');
      $("#upload_btn").val('');
      return false;
    }else if (FileSize > 10) {
      alert('File size exceeds 10 MB');
      $("#upload_btn").val('');
      return false;
    }  
  });


// MY ACCOUNT PAGES
  $('.btn-print').on('click',function(){
    var $this = $(this).parents('.account_order-content');
    printDiv($this);
  });  
   
  function printDiv(divName) {
    var printContents = divName.html();
    var originalContents = $('body').html();
    $('body').html(printContents);	    
    window.print();    
    $('body').css('opacity','0');
    $('body').html(originalContents);          
    $('body').css('opacity','1');

    //     location.reload();
    setTimeout(function(){
      $('body').removeClass('site-header-sticky--scrolled');
      $('.shopify-section.site-header-wrapper').addClass('site-header-sticky--open');      
    },1000);

    $(window).scroll(function(){
      if(!$('.site-header-sticky').hasClass('site-header-sticky--scrolled')){
        $('.shopify-section.site-header-wrapper').removeClass('visible').addClass('site-header-sticky--open'); 
      }
      else{
        $('.shopify-section.site-header-wrapper').removeClass('site-header-sticky--open').addClass('visible');         
      }      
    });
  }
  
  var $rows = $('.account-page-content.account_order-wrap .account_order-content');
  $('.order-search-form button.order-search-button').click(function(e){
    e.preventDefault();
    
    $('.order-search li').removeClass('active');
    $('.order-search li:last').addClass('active');
    
    var inp_val = $.trim($('.order-search-form input').val()).replace(/ +/g, ' ').toLowerCase();
    
    if(inp_val != ''){
      $rows.show().filter(function() {
        var text = $(this).find('.order-title').text().replace(/\s+/g, ' ').toLowerCase();
        text += $(this).find('.oder-id').text().replace(/\s+/g, ' ').toLowerCase();
        return !~text.indexOf(inp_val);
      }).hide();
      
      if($('.account-page-content.account_order-wrap .account_order-content:visible').length < 1){
      	$('.noRecord').show();
      }
      else{
      	$('.noRecord').hide();
      }
    }
    else{
      $rows.show();
      $('.noRecord').hide();
    }
  });
  
  $('.order-search a').click(function(e){
    e.preventDefault();
    $('.order-search li').removeClass('active');
    $(this).parent('li').addClass('active');  	
    
    $('.order-search-form input').val('');
    
    var data_search = $(this).attr('data-search');
    if(data_search == 'all'){
      $rows.show();
      $('.noRecord').hide();
    }
    else{
      $('.oder-status').each(function(){
      	var data_status = $(this).attr('data-status');
        if(data_search == data_status){
          $(this).parents('.account-page-content.account_order-wrap .account_order-content').show();
        }
        else{
          $(this).parents('.account-page-content.account_order-wrap .account_order-content').hide();
        }
      });
      $('.noRecord').hide();
    }
    
    if($('.account-page-content.account_order-wrap .account_order-content:visible').length < 1){
      $('.noRecord').show();
    }
    else{
      $('.noRecord').hide();
    }
    
  });
  
//   $('#reset_password').click(function(e){
//  $("form").attr('autocomplete', 'off');
//   e.preventDefault();
//   $("body").addClass("login_popped_Up");
//   $.magnificPopup.open({
//     items: {
//       src: '#reset_password_form',
//       type: 'inline'
// //       callbacks: {
// //         beforeOpen: function () {
// //           if ($(window).width() < 700) {
// //             this.st.focus = false;
// //           } else {
// //             this.st.focus = '#name';
// //           }
// //         }
// //       }
//     }
//   });
//   $.magnificPopup.instance.close = function () {
//     if ($("body").hasClass("login_popped_Up")) {
//       $("body").removeClass("login_popped_Up");
//     }
// //     $('form').find("input[type=text], input[type=password]").val("");
//      $.magnificPopup.proto.close.call(this);
// };
// });
var hash = window.location.hash;
var reset_password=0;
   if (hash === '#reset_password') {
      $('a[data-login-toggle]').trigger("click");
   	   reset_password=1;
   }else{
   reset_password=0;
   }
  
  if(reset_password==1){
    $('.account-page-title').hide();
    $('button[data-login-toggle]').hide();
  }else{
      $('.account-page-title').show();
    $('button[data-login-toggle]').show();
  }
});

if($('.address-slider').length > 0){
  $('.address-slider').slick({
    slidesToShow:4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow:3,
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow:2,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow:1,
        }
      }
    ]
  });
}

function validateEmail($email) {
//   var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
  var emailReg  = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
  return emailReg.test( $email );
}

$('.newsletter button[type="submit"]').click(function(e){
  var emailaddress = $('.newsletter input[type="email"]').val();
  if(emailaddress != ''){
    if( !validateEmail(emailaddress)) {
      $('.error_newsletter').removeClass('hide');
      return false;      
    }
    else{
      $('.error_newsletter').addClass('hide');
      return true; 
//       $('.newsletter form').submit();
    }
  } 
  else{ 
    $('.error_newsletter').removeClass('hide');
      return false;   
  }
});

/*-- UK@DD --*/

// $('button[name="checkout"]').click(function(){
//   var dd_carttotal = 0;
//   $('article.cart-item').each(function() {
//     dd_carttotal += parseInt($(this).attr("data-cartitem-total"));
//   });
  
//   if(dd_carttotal < 15000){
//     if(exclude_customer){
//       return true;
//     } else {
//     	alert("Minimum order must be $150");
//     }
//   	return false;  
//   } else {
//   	return true;
//   }
// });
$("input#bc-sf-search-box-1 , input.site-header-search-form-field ").on(' focus blur keyup', function (e) {
$('div.navmenu-submenu').removeClass("visible");
$('div.navmenu-submenu').addClass("hidden");
$('li a').removeClass("navmenu-active navmenu-item-active");
});